import { Product } from 'graphql-api/gql-api-interfaces';

import { State } from '../models/state';

export const enrichProductsWithPrices = (
  products: Product[],
  discounts: State,
): Product[] => {
  return products.map((product) => {
    const discount = +discounts[product.productId];
    if (!!discount) {
      const priceRanges =
        product.priceRanges.length > 0
          ? product.priceRanges.map((priceRange) => ({
              ...priceRange,
              discount: { max: discount, min: discount },
            }))
          : [{ discount: { max: discount, min: discount } }];
      return {
        ...product,
        priceRanges,
      };
    }

    return product;
  });
};
